import AbstractController from '../../../Controller/AbstractController';
import Controller from '../../../Controller/Controller';
import MemberSlider from '../Elements/MemberSlider';

/**
 * Team Controller
 *
 * @class
 */
class TeamController extends AbstractController {
  /**
   * @constructor
   */
  constructor() {
    super();

    Controller.registerController(this);
    this._registerElements(...MemberSlider);
  }
}

export default new TeamController();
